import { DateTime } from "luxon";

export function isDateTime(date: unknown): date is DateTime {
  return DateTime.isDateTime(date);
}
